import React, { useContext, useEffect, useState } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Pagination,
  PaginationItem,
  PaginationLink,
  Row,
} from "reactstrap";
import SignContext from "../../contextAPI/Context/SignContext";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import axios from "axios";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Link } from "react-router-dom";
import * as XLSX from "xlsx";
import "../Pages/PrintForm/printForm.css";
const url = `${process.env.REACT_APP_BASE_URL}`;

const MedicalReports = () => {
  const [allCompany, setAllCompany] = useState([]);
  const [allLocation, setAllLocation] = useState([]);
  const [allName, setAllName] = useState([]);
  const [allCheckupType, setAllCheckupType] = useState(null);
  const [filterdata, setFilterdata] = useState(null);
  const [f1, setf1] = useState("");
  const [f2, setf2] = useState("");
  const [f3, setf3] = useState("");
  const [f4, setf4] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  // Pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [totalPages, setTotalPages] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [allFilteredData, setAllFilteredData] = useState(null); // For export

  const { GetCompany, GetCompanybyId, GetCheckUpName, getCheckupType } =
    useContext(SignContext);

  const getcompanies = async () => {
    const res = await GetCompany();

    // Handle both paginated (res.data.data) and non-paginated (res.data) responses
    const companyData = Array.isArray(res.data)
      ? res.data
      : res.data.data || [];
    setAllCompany(companyData);
  };

  const getcheckupname = async () => {
    const res = await GetCheckUpName();

    setAllName(res.data);
  };
  const getAllCheckupType = async () => {
    const responce = await getCheckupType();


    setAllCheckupType(responce.data);
  };

  const handleLocationChange = (e) => {
    let selectedCompanyId = e.target.value;
        setf1(selectedCompanyId);
            if (selectedCompanyId) {
      getcompaniesbyId(selectedCompanyId);
    }
  };

  const handle1 = (e) => {
    let selectedCompanyId = e.target.value;

    setf2(selectedCompanyId);
  };
  const handle2 = (e) => {
    let selectedCheckupNameId = e.target.value;

    setf3(selectedCheckupNameId);
  };

  const handle3 = (e) => {
    let selectedCheckuptypeId = e.target.value;

    setf4(selectedCheckuptypeId);
  };

  const getcompaniesbyId = async (id) => {
    const res = await GetCompanybyId(id);
    setAllLocation(res.data.companyLocation);
    // (res.data.companyJobCategorys);
    // setDepartment(res.data.companyDepartments);
    // setRoles(res);
  };

  const handleDateChange = (date, field) => {

    if (field === "start") {
      setStartDate(date);
    } else if (field === "end") {
      setEndDate(date);
    }
  };

  const handleFetchData = async (page = currentPage, pageLimit = limit) => {
    const queryParams = {
      companyId: f1,
      location: f2,
      checkupNameId: f3,
      checkupTypeId: f4,
      page: page,
      limit: pageLimit,
    };

    if (startDate) {
      const formattedStartDate = new Date(startDate).toLocaleDateString(
        "en-US",
        {
          month: "2-digit",
          day: "2-digit",
          year: "numeric",
        },
      );
      queryParams.startDate = formattedStartDate;
    }

    if (endDate) {
      const formattedEndDate = new Date(endDate).toLocaleDateString("en-US", {
        month: "2-digit",
        day: "2-digit",
        year: "numeric",
      });
      queryParams.endDate = formattedEndDate;
    }

    // Use lightweight endpoint for list view
    const endpoint = "/checkup/get-checkup-data-list";

    const queryString = Object.keys(queryParams)
      .map((key) => `${key}=${queryParams[key]}`)
      .join("&");

    const url1 = `${url}${endpoint}?${queryString}`;

    try {
      const response = await axios.get(url1);


      // Handle axios interceptor response structure
      if (response && response.data) {
        setFilterdata(response.data);

        // Update pagination metadata
        if (response.pagination) {
          setCurrentPage(response.pagination.currentPage);
          setTotalPages(response.pagination.totalPages);
          setTotalRecords(response.pagination.totalRecords);
        }
      }
    } catch (error) {

      setFilterdata([]);
      setTotalPages(0);
      setTotalRecords(0);
    }
  };

  // Fetch all data for export (without pagination)
  const fetchAllDataForExport = async () => {
    const queryParams = {
      companyId: f1,
      location: f2,
      checkupNameId: f3,
      checkupTypeId: f4,
      limit: 999999, // Get all records
    };

    if (startDate) {
      const formattedStartDate = new Date(startDate).toLocaleDateString(
        "en-US",
        {
          month: "2-digit",
          day: "2-digit",
          year: "numeric",
        },
      );
      queryParams.startDate = formattedStartDate;
    }

    if (endDate) {
      const formattedEndDate = new Date(endDate).toLocaleDateString("en-US", {
        month: "2-digit",
        day: "2-digit",
        year: "numeric",
      });
      queryParams.endDate = formattedEndDate;
    }

    const endpoint = "/checkup/get-all-checkup-data";
    const queryString = Object.keys(queryParams)
      .map((key) => `${key}=${queryParams[key]}`)
      .join("&");

    const url1 = `${url}${endpoint}?${queryString}`;

    try {
      const response = await axios.get(url1);
      return response && response.data ? response.data : [];
    } catch (error) {

      return [];
    }
  };

  const handleExportReport = async () => {
    // Fetch all filtered data for export
    const dataToExport = await fetchAllDataForExport();

    if (dataToExport && dataToExport.length > 0) {
      const headers = [
        "NAME",
        "FATHER NAME",
        "SURNAME",
        "AGE",
        "SEX",
        "DATE",
        "HEIGHT",
        "WEIGHT",
        "BMI",
        "PRESENT COMPLAINT",
        "PAST ILLNESS",
        "FAMILY HISTORY",
        "CURRENT MEDICATION",
        "ALLERGY",
        "PERSONAL HISTORY",
        "B.P",
        "PULSE",
        "W/O GLASS DISTANT RIGHT",
        "W/O GLASS DISTANT LEFT",
        "W/O GLASS NEAR RIGHT",
        "W/O GLASS NEAR LEFT",
        "WITH GLASS DISTANT RIGHT",
        "WITH GLASS DISTANT LEFT",
        "WITH GLASS NEAR RIGHT",
        "WITH GLASS NEAR LEFT",
        "COLOUR BLINDNESS",
        "HAEMOGLOBIN",
        "W.B.C",
        "PLATELET COUNT",
        "BLOOD GROUP",
        "RANDOM SUGAR",
        "Sugar PP2BS",
        "Blood Urea",
        "Bun",
        "S Creatine",

        "SGPT",
        "SGot",
        "S.BilirubinTotal",
        "S.Bilirubin Direct",
        "S.Bilirubin InDirect",
        "Alkaline Phosphatase",
        "S.protiens",
        "Albumin",
        "Globulin",
        "Sodium",
        "Potassium",
        "Chloride",
        "S.cholesterol",
        "hdlchloestrol",
        "ldlchlorestal",
        "s.triglucerides",
        "stool r&m",

        "SPIROMETRY",
        "AUDIOMETRY",
        "ECG report",
        "X-RAY(CHEST)",
        "FINAL REMARK",
        "FIT",
        "CELL NO",
        "DOB",
        "VACCINE DOSE",
        "MC CODE",
        "SHOE SIZE",
      ];

      const data = dataToExport.map((item) => [
        (item.employeeData && item.employeeData.employeeName) || "NA",
        (item.employeeData && item.employeeData.employeeFatherName) || "NA",
        (item.employeeData && item.employeeData.employeeSurname) || "NA",
        (item.employeecontactdetails && item.employeecontactdetails.age) ||
        "NA",
        (item.employeecontactdetails && item.employeecontactdetails.gender) ||
        "NA",
        (item.checkupDate &&
          item.checkupDate.slice(0, 10).split("-").reverse().join("-")) ||
        "NA",
        (item.employeeVitalAndHistory && item.employeeVitalAndHistory.height) ||
        "NA",
        (item.employeeVitalAndHistory && item.employeeVitalAndHistory.weight) ||
        "NA",
        (item.employeeVitalAndHistory && item.employeeVitalAndHistory.bmi) ||
        "NA",
        (item.employeeVitalAndHistory &&
          item.employeeVitalAndHistory.complaints) ||
        "NA",
        (item.employeeVitalAndHistory &&
          item.employeeVitalAndHistory.pastHistory) ||
        "NA",

        (item.employeeVitalAndHistory &&
          item.employeeVitalAndHistory.familyHistory) ||
        "NA",
        (item.employeeVitalAndHistory &&
          item.employeeVitalAndHistory.currentMedication) ||
        "NA",
        (item.employeeVitalAndHistory &&
          item.employeeVitalAndHistory.allergy) ||
        "NA",
        (item.employeeVitalAndHistory &&
          item.employeeVitalAndHistory.personalHistory) ||
        "NA",
        (item.employeeVitalAndHistory && item.employeeVitalAndHistory.bp) ||
        "NA",
        (item.employeeVitalAndHistory && item.employeeVitalAndHistory.pulse) ||
        "NA",
        (item.employeeeyeinformation &&
          item.employeeeyeinformation.distandVisionWithoutRightEye) ||
        "NA",
        (item.employeeeyeinformation &&
          item.employeeeyeinformation.distandVisionWithoutLeftEye) ||
        "NA",
        (item.employeeeyeinformation &&
          item.employeeeyeinformation.nearVisionWithoutRightEye) ||
        "NA",
        (item.employeeeyeinformation &&
          item.employeeeyeinformation.nearVisionWithoutLeftEye) ||
        "NA",
        (item.employeeeyeinformation &&
          item.employeeeyeinformation.distandVisionWithRightEye) ||
        "NA",
        (item.employeeeyeinformation &&
          item.employeeeyeinformation.distandVisionWithLeftEye) ||
        "NA",
        (item.employeeeyeinformation &&
          item.employeeeyeinformation.nearVisionWithRightEye) ||
        "NA",
        (item.employeeeyeinformation &&
          item.employeeeyeinformation.nearVisionWithLefttEye) ||
        "NA",
        (item.employeeeyeinformation &&
          item.employeeeyeinformation.colourVision) ||
        "NA",
        (item.employeebloodinformation && item.employeebloodinformation.hb) ||
        "NA",
        (item.employeebloodinformation && item.employeebloodinformation.wbc) ||
        "NA",
        (item.employeebloodinformation &&
          item.employeebloodinformation.plateletCount) ||
        "NA",
        (item.employeecontactdetails &&
          item.employeecontactdetails.bloodGroup) ||
        "NA",

        item.employeebloodinformation &&
          item.employeebloodinformation.blSugarFastingOrRandom
          ? item.employeebloodinformation.blSugarFastingOrRandom
          : "NA",
        (item.employeebloodinformation &&
          item.employeebloodinformation.blSugarPP2BS) ||
        "NA",
        (item.employeebloodinformation &&
          item.employeebloodinformation.blUrea) ||
        "NA",
        (item.employeebloodinformation && item.employeebloodinformation.bun) ||
        "NA",
        (item.employeebloodinformation &&
          item.employeebloodinformation.sCreatinine) ||
        "NA",
        (item.employeebloodinformation && item.employeebloodinformation.sgpt) ||
        "NA",
        (item.employeebloodinformation && item.employeebloodinformation.sgot) ||
        "NA",
        (item.employeebloodinformation &&
          item.employeebloodinformation.sBilirubinTotal) ||
        "NA",
        (item.employeebloodinformation &&
          item.employeebloodinformation.sBilirubinDirect) ||
        "NA",
        (item.employeebloodinformation &&
          item.employeebloodinformation.sBilirubinIndirect) ||
        "NA",
        (item.employeebloodinformation &&
          item.employeebloodinformation.sProteins) ||
        "NA",
        (item.employeebloodinformation &&
          item.employeebloodinformation.alklinePhosphatase) ||
        "NA",
        (item.employeebloodinformation &&
          item.employeebloodinformation.albumin) ||
        "NA",
        (item.employeebloodinformation &&
          item.employeebloodinformation.globulin) ||
        "NA",
        (item.employeebloodinformation &&
          item.employeebloodinformation.sodium) ||
        "NA",
        (item.employeebloodinformation &&
          item.employeebloodinformation.potassuim) ||
        "NA",
        (item.employeebloodinformation &&
          item.employeebloodinformation.chloride) ||
        "NA",

        (item.employeebloodinformation &&
          item.employeebloodinformation.scholesterol) ||
        "NA",
        (item.employeebloodinformation &&
          item.employeebloodinformation.hdlcholesterol) ||
        "NA",
        (item.employeebloodinformation &&
          item.employeebloodinformation.ldlcholesterol) ||
        "NA",
        (item.employeebloodinformation &&
          item.employeebloodinformation.striglucerides) ||
        "NA",
        (item.employeebloodinformation &&
          item.employeebloodinformation.stoolrm) ||
        "NA",
        (item.employeeinvestigationinformation &&
          item.employeeinvestigationinformation.spirometry) ||
        "NA",
        (item.employeeinvestigationinformation &&
          item.employeeinvestigationinformation.audiometry) ||
        "NA",
        (item.employeeinvestigationinformation &&
          item.employeeinvestigationinformation.ecgReport) ||
        "NA",
        (item.employeeinvestigationinformation &&
          item.employeeinvestigationinformation.xRayReport) ||
        "NA",
        (item.employeeinvestigationinformation &&
          item.employeeinvestigationinformation.remarks) ||
        "NA",
        (item.employeeform33 && item.employeeform33.fitOrUnfit) || "NA",
        (item.employeecontactdetails &&
          item.employeecontactdetails.mobileNumber) ||
        "NA",
        (item.employeecontactdetails &&
          item.employeecontactdetails.dateOfBirth &&
          item.employeecontactdetails.dateOfBirth
            .slice(0, 10)
            .split("-")
            .reverse()
            .join("-")) ||
        "NA",
      ]);

      const headerStyle = {
        alignment: {
          horizontal: "center",
          vertical: "center",
        },
        font: { bold: true },
      };

      const dataStyle = {
        alignment: {
          horizontal: "center",
          vertical: "center",
        },
      };

      const styles = [headerStyle];
      for (let i = 1; i < data.length; i++) {
        styles.push(dataStyle);
      }

      const worksheet = XLSX.utils.aoa_to_sheet([headers, ...data], { styles });
      const colWidths = [
        20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20,
        20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20,
        20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20,
        20, 20, 20, 20, 20, 20,
      ];
      worksheet["!cols"] = colWidths.map((width) => ({ width }));
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "MedicalReports");

      // Save the file
      XLSX.writeFile(workbook, "MedicalReports.xlsx");
    } else {
      // Display a message or handle the case where no data is available

      alert("No data available to export");
    }
  };

  useEffect(() => {
    getcompanies();
    getcheckupname();
    getAllCheckupType();
  }, []);

    
  return (
    <>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb grandParent="Setup" parent="Reports" child="Reports" />
          <Row>
            <Col lg={12}>
              <Card>
                <CardHeader className="d-flex justify-content-between align-items-center">
                  <Row className="align-items-center">
                    <Col lg={2} md={6} className="tablet-responsive">
                      <select
                        className="form-select"
                        id="filterSelect"
                        // style={{ marginLeft: "4px" }}
                        //   value={filterOption}
                        onChange={handleLocationChange}
                      >
                        <option value="">Select Company</option>
                        {allCompany
                          ? allCompany.map((company) => (
                            <option key={company._id} value={company._id}>
                              {company.companyName}
                            </option>
                          ))
                          : null}
                      </select>
                    </Col>
                    <Col lg={2} md={6} className="tablet-responsive">
                      <select
                        className="form-select"
                        id="filterSelect"
                        // style={{ marginLeft: "14px" }}
                        onChange={handle1}
                      >
                        <option value="">Select Location</option>
                        {allLocation && allLocation.length > 0 ? (
                          allLocation.map((location) => (
                            <option key={location} value={location}>
                              {location}
                            </option>
                          ))
                        ) : (
                          <option value="" disabled>
                            No locations available
                          </option>
                        )}
                      </select>
                    </Col>
                    <Col lg={2} md={6} className="tablet-responsive">
                      <select
                        className="form-select"
                        id="filterSelect"
                        // style={{ marginLeft: "14px" }}
                        onChange={handle2}
                      >
                        <option value="">Select Checkup</option>
                        {allName.length
                          ? allName.map((checkupName) => (
                            <option key={checkupName} value={checkupName._id}>
                              {checkupName.checkupName}
                            </option>
                          ))
                          : null}
                      </select>
                    </Col>
                    <Col lg={2} md={6} className="tablet-responsive">
                      <select
                        className="form-select"
                        id="filterSelect"
                        // style={{ marginLeft: "14px" }}
                        onChange={handle3}
                      >
                        <option value="">Select Type</option>
                        {allCheckupType
                          ? allCheckupType.map((checkupType) => (
                            <option key={checkupType} value={checkupType._id}>
                              {checkupType.checkupType}
                            </option>
                          ))
                          : null}
                      </select>
                    </Col>
                    <Col lg={2} md={6} className="tablet-responsive">
                      <DatePicker
                        className="form-control"
                        selected={startDate}
                        onChange={(date) => handleDateChange(date, "start")}
                        dateFormat="dd/MM/yyyy"
                        placeholderText="Select Start Date"
                      />
                    </Col>
                    <Col lg={2} md={6} className="tablet-responsive">
                      <DatePicker
                        className="form-control"
                        selected={endDate}
                        onChange={(date) => handleDateChange(date, "end")}
                        dateFormat="dd/MM/yyyy" // Set the desired date format
                        placeholderText="Select End Date"
                      />
                    </Col>
                  </Row>

                  {/* <div className="filter-dropdown " style={{ display: "flex" }}>
                    <button
                      onClick={handleFetchData}
                      style={{ marginLeft: "24px", width: "100%" }}
                    >
                      Apply
                    </button>
                  </div> */}
                  <div className="filter-dropdown" style={{ display: "flex" }}>
                    <button
                      onClick={() => {
                        setCurrentPage(1); // Reset to page 1 when applying new filters
                        handleFetchData(1, limit);
                      }}
                      style={{
                        marginLeft: "24px",
                        width: "100%",
                        padding: "10px 20px",
                        backgroundColor: "#4CAF50" /* Green background color */,
                        color: "white" /* White text color */,
                        border: "none" /* Remove borders */,
                        borderRadius: "5px" /* Rounded corners */,
                        cursor: "pointer" /* Add a pointer cursor on hover */,
                        transition:
                          "background-color 0.3s" /* Smooth transition on hover */,
                      }}
                      onMouseOver={(e) =>
                        (e.target.style.backgroundColor = "#45a049")
                      } /* Darken the button on hover */
                      onMouseOut={(e) =>
                        (e.target.style.backgroundColor = "#4CAF50")
                      } /* Revert the color on hover out */
                    >
                      Apply
                    </button>
                  </div>

                  <Row className="align-items-center">
                    <Col className="col-lg-auto"></Col>
                  </Row>
                </CardHeader>
                <CardBody>
                  <div id="contentList">
                    <div className="table-responsive table-card mt-1 mb-3">
                      <table
                        className="table align-middle table-nowrap"
                        id="customerTable"
                      >
                        <thead className="table-light">
                          <tr>
                            <th
                              className="name"
                              style={{ width: "250px", textAlign: "center" }}
                            >
                              Name
                            </th>
                            <th
                              className="name"
                              style={{ textAlign: "center" }}
                            >
                              Medical Check Up
                            </th>
                            <th
                              className="name"
                              style={{ textAlign: "center" }}
                            >
                              Form 33 Health
                            </th>
                            <th
                              className="name"
                              style={{ textAlign: "center" }}
                            >
                              Form 32
                            </th>
                            <th
                              className="name"
                              style={{ textAlign: "center" }}
                            >
                              Health Card.
                            </th>
                          </tr>
                        </thead>

                        <tbody className="list form-check-all">
                          {filterdata && filterdata.length > 0 ? (
                            filterdata.map((item, index) => (
                              <tr
                                key={index}
                                value={item.employeeName}
                              >
                                <td
                                  className="product-name"
                                  style={{ textAlign: "center" }}
                                >
                                  {item.employeeName || "N/A"}
                                </td>
                                <td
                                  className="product-name"
                                  style={{ textAlign: "center" }}
                                >
                                  <Link
                                    to={`/medical-report/${item._id}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    Medical Report
                                  </Link>
                                </td>

                                <td
                                  className="product-name"
                                  style={{ textAlign: "center" }}
                                >
                                  <Link
                                    to={`/form-helth33/${item._id}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    Form-Health33 Report
                                  </Link>
                                </td>
                                <td
                                  className="product-name"
                                  style={{ textAlign: "center" }}
                                >
                                  <Link
                                    to={`/form32/${item._id}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    Form 32 Report
                                  </Link>
                                </td>

                                <td
                                  className="product-name"
                                  style={{ textAlign: "center" }}
                                >
                                  <Link
                                    to={`/helth-card/${item._id}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    Health Card
                                  </Link>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td
                                colSpan="5"
                                className="text-center"
                                style={{ padding: "40px", fontSize: "16px", color: "#6c757d" }}
                              >
                                {filterdata === null ? (
                                  "Please apply filters to view reports"
                                ) : (
                                  <>
                                    <i className="ri-file-search-line" style={{ fontSize: "48px", display: "block", marginBottom: "10px", opacity: 0.5 }}></i>
                                    <strong>No data found</strong>
                                    <br />
                                    <small>Try adjusting your filters</small>
                                  </>
                                )}
                              </td>
                            </tr>
                          )}
                        </tbody>

                        {/* <tbody className="list form-check-all">
                          {filterdata
                            ? filterdata.map((item, index) => (
                                <tr
                                  key={index}
                                  value={item.employeeData.employeeName}
                                >
                                  <td
                                    className="product-name"
                                    style={{ textAlign: "center" }}
                                  >
                                    {item.employeeData.employeeName}
                                  </td>
                                </tr>
                              ))
                            : null}
                        </tbody> */}
                      </table>
                    </div>
                  </div>

                  {/* Pagination Info and Controls */}
                  {filterdata && filterdata.length > 0 && (
                    <>
                      <div className="d-flex justify-content-between align-items-center mt-3 mb-3">
                        <div className="d-flex align-items-center gap-2">
                          <span className="text-muted">
                            Showing {((currentPage - 1) * limit) + 1} to{" "}
                            {Math.min(currentPage * limit, totalRecords)} of{" "}
                            {totalRecords} records
                          </span>
                          <select
                            className="form-select form-select-sm"
                            style={{ width: "auto" }}
                            value={limit}
                            onChange={(e) => {
                              const newLimit = parseInt(e.target.value);
                              setLimit(newLimit);
                              setCurrentPage(1);
                              handleFetchData(1, newLimit);
                            }}
                          >
                            <option value="10">10 per page</option>
                            <option value="25">25 per page</option>
                            <option value="50">50 per page</option>
                            <option value="100">100 per page</option>
                          </select>
                        </div>

                        {totalPages > 1 && (
                          <Pagination className="mb-0">
                            <PaginationItem disabled={currentPage === 1}>
                              <PaginationLink
                                first
                                onClick={() => {
                                  setCurrentPage(1);
                                  handleFetchData(1);
                                }}
                              />
                            </PaginationItem>
                            <PaginationItem disabled={currentPage === 1}>
                              <PaginationLink
                                previous
                                onClick={() => {
                                  const prevPage = currentPage - 1;
                                  setCurrentPage(prevPage);
                                  handleFetchData(prevPage);
                                }}
                              />
                            </PaginationItem>

                            {/* Page Numbers */}
                            {(() => {
                              const pages = [];
                              const maxPagesToShow = 5;
                              let startPage = Math.max(
                                1,
                                currentPage - Math.floor(maxPagesToShow / 2)
                              );
                              let endPage = Math.min(
                                totalPages,
                                startPage + maxPagesToShow - 1
                              );

                              if (endPage - startPage < maxPagesToShow - 1) {
                                startPage = Math.max(1, endPage - maxPagesToShow + 1);
                              }

                              for (let i = startPage; i <= endPage; i++) {
                                pages.push(
                                  <PaginationItem key={i} active={i === currentPage}>
                                    <PaginationLink
                                      onClick={() => {
                                        setCurrentPage(i);
                                        handleFetchData(i);
                                      }}
                                    >
                                      {i}
                                    </PaginationLink>
                                  </PaginationItem>
                                );
                              }
                              return pages;
                            })()}

                            <PaginationItem disabled={currentPage === totalPages}>
                              <PaginationLink
                                next
                                onClick={() => {
                                  const nextPage = currentPage + 1;
                                  setCurrentPage(nextPage);
                                  handleFetchData(nextPage);
                                }}
                              />
                            </PaginationItem>
                            <PaginationItem disabled={currentPage === totalPages}>
                              <PaginationLink
                                last
                                onClick={() => {
                                  setCurrentPage(totalPages);
                                  handleFetchData(totalPages);
                                }}
                              />
                            </PaginationItem>
                          </Pagination>
                        )}
                      </div>
                    </>
                  )}

                  <div className="hstack gap-2 justify-content-end d-print-none mt-4">
                    <Link
                      to="#"
                      onClick={handleExportReport}
                      className="btn btn-success"
                    >
                      <i className="ri-printer-line align-bottom me-1"></i>{" "}
                      Export Report
                    </Link>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default MedicalReports;
